var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewsletterinline = function SvgNewsletterinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#0073E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.125 7.5h-8.25c-.365 0-.714.139-.972.386a1.29 1.29 0 0 0-.403.931v.264l5.5 2.964 5.5-2.898v-.33c0-.349-.145-.684-.403-.931a1.406 1.406 0 0 0-.972-.386"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.656 13.142 6.5 10.375v4.808c0 .35.145.685.403.932s.607.386.972.386h8.25c.365 0 .714-.139.972-.386a1.29 1.29 0 0 0 .403-.932v-4.808l-5.156 2.767a.887.887 0 0 1-.688 0"
  })));
};
export default SvgNewsletterinline;